/* a replacement for our cookie permissions package to stay backward compatible */

export function init() {
    if (_config.registerPermissionGrantedCallback) {
        _config.registerPermissionGrantedCallback.forEach(function (obj) {
            obj.callback();
            console.log('call', obj);
        });
    }
}